import { TranscribeClient } from "@aws-sdk/client-transcribe";
import { S3Client } from "@aws-sdk/client-s3";

// AWS China regions
export const AWS_CHINA_REGIONS = {
  BEIJING: "cn-north-1",
  NINGXIA: "cn-northwest-1",
} as const;

// Environment variable keys for AWS China
export const AWS_CHINA_ENV_VARS = {
  ACCESS_KEY_ID: "REACT_APP_AWS_CHINA_ACCESS_KEY_ID",
  SECRET_ACCESS_KEY: "REACT_APP_AWS_CHINA_SECRET_ACCESS_KEY",
  REGION: "REACT_APP_AWS_CHINA_REGION",
  S3_BUCKET: "REACT_APP_AWS_CHINA_S3_BUCKET",
} as const;

// Interface for AWS China configuration
export interface AWSChinaConfig {
  accessKeyId: string;
  secretAccessKey: string;
  region: string;
  s3Bucket: string;
}

/**
 * Gets AWS China configuration from environment variables
 * @returns AWSChinaConfig object with validated credentials
 * @throws Error if environment variables are not properly configured
 */
export function getAWSChinaConfig(): AWSChinaConfig {
  return {
    accessKeyId: "AKIASV2AELUUZWVJD4A4",
    secretAccessKey: "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",
    region: "cn-north-1",
    s3Bucket: "boxwhy",
  };
}

/**
 * Creates a configured Transcribe client for AWS China
 * @returns TranscribeClient configured for AWS China region
 */
export function createAWSChinaTranscribeClient(): TranscribeClient {
  const config = getAWSChinaConfig();

  return new TranscribeClient({
    region: config.region,
    credentials: {
      accessKeyId: config.accessKeyId,
      secretAccessKey: config.secretAccessKey,
    },
    // AWS China specific endpoint configuration
    endpoint: `https://transcribe.${config.region}.amazonaws.com.cn`,
  });
}

/**
 * Creates a configured S3 client for AWS China
 * @returns S3Client configured for AWS China region
 */
export function createAWSChinaS3Client(): S3Client {
  const config = getAWSChinaConfig();

  return new S3Client({
    region: config.region,
    credentials: {
      accessKeyId: config.accessKeyId,
      secretAccessKey: config.secretAccessKey,
    },
    // AWS China specific endpoint configuration
    endpoint: `https://s3.${config.region}.amazonaws.com.cn`,
  });
}
